export const isLabel = (label, argument) => {
  if (label.toLowerCase().replace(/\s+/g, '') === argument) {
    return true;
  }
};
